import { createStore } from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
import { createLogger } from 'vuex'
import createWebSocketPlugin from '../api/websocketplugin'
import { DEBUG_MODE } from '../utils/paramUtils'

const state = {
  userInfo: {},
  isConnected: false,
  isConnectFail: false,
  currentThreadID: null,
  threads: {}, /*id: {id,name,messages: [...ids],lastMessage, lastLoginTime, unreadCount, waitMessages, waitLastMessage, dragMessage,loadend} */
  threadIds: [],
  listResendMessage: [],
  messages: {},
  lang: 'en',
  isOpenChat: false,
  isLoadingRoom: true,
  isLoadingMessage: true,
  loadInitData: false,
  loadedInitData: false,
  statusApp: 0,
  threadSwitch: false,
}

const plugins = [createWebSocketPlugin()]
if (DEBUG_MODE) {
  plugins.push(createLogger())
}

export default createStore({
  strict: process.env.NODE_ENV !== 'production',
  state,
  getters,
  mutations,
  actions,
  modules: {
  },
  plugins: plugins
})



